import api from "./api"

export const getStockMovements = async () => {
  const response = await api.get("/stock-movements")
  return response.data
}

export const getStockMovementById = async (movementId) => {
  const response = await api.get(`/stock-movements/${movementId}`)
  return response.data
}

export const getStockMovementFormData = async () => {
  const response = await api.get("/stock-movements/form-data")
  return response.data
}

export const createStockMovement = async (payload) => {
  const response = await api.post("/stock-movements", payload)
  return response.data
}

export const updateStockMovement = async (movementId, payload) => {
  const response = await api.put(`/stock-movements/${movementId}`, payload)
  return response.data
}

export const deleteStockMovement = async (movementId) => {
  const response = await api.delete(`/stock-movements/${movementId}`)
  return response.data
}